import { render } from "./ObjectOnMapModal.vue?vue&type=template&id=46b92610"
import script from "./ObjectOnMapModal.vue?vue&type=script&lang=js"
export * from "./ObjectOnMapModal.vue?vue&type=script&lang=js"

import "./ObjectOnMapModal.vue?vue&type=style&index=0&id=46b92610&lang=scss"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__